const initialState ={
    sites: []
}

export const sitesReducer=(state=initialState, action) => {
    
    switch (action.type) {
        case 'GET_ALL_JOBS' : return{
            ...state,
            sites : action.payload
        }
        default : return state
    }
}